import React from 'react';

import withModal from '../../../../../../components/global/modal/withModal';
import RosterIdentityRosterQrAssignment from '.';

export const IDENTITY_ROSTER_QR_ASSIGNMENT_MODAL =
  'modals/IDENTITY_ROSTER_QR_ASSIGNMENT_MODAL';

const RosterIdentityRosterQrAssignmentModal = props => (
  <RosterIdentityRosterQrAssignment {...props} />
);

export default withModal(RosterIdentityRosterQrAssignmentModal, {
  name: IDENTITY_ROSTER_QR_ASSIGNMENT_MODAL,
  size: 'sm',
  type: 'full',
  hideHeader: true,
  overlayClassName: 'z-modal-max',
});
